import(/* webpackMode: "eager" */ "/build/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["PrefetchOverride"] */ "/build/packages/web/src/app/prefetch-override.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider","AuthContext"] */ "/build/packages/web/src/components/auth-provider/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarProvider"] */ "/build/packages/web/src/components/sidebar/sidebar-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sidebar"] */ "/build/packages/web/src/components/sidebar/sidebar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeRegistry"] */ "/build/packages/web/src/components/theme/theme-registry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/build/packages/web/src/i18n/i18n-provider/i18n-provider.tsx");
